/* ══════════════════════════════════════════════════════
   HİKÂYE METNİ
   Her akt kendi metnini buradan alır. Tamamı Türkçe.
   ══════════════════════════════════════════════════════ */

export const brand = { name: 'Agren', suffix: 'AI' };

export const nav = {
  links: [
    { label: 'Özellikler', href: '#ozellikler' },
    { label: 'Nasıl Çalışır', href: '#uydudan' },
    { label: 'Güven', href: '#sistem' },
    { label: 'Hakkımızda', href: '#hakkimizda' },
    { label: 'SSS', href: '#sss' },
  ],
  cta: 'Uygulamayı İndir',
};

/* ACT 01 — kök inişi */
export const act01 = {
  title: ['Tarımın yeni', 'yapay zekâsı.'],
  subtitle: 'Agren AI, tarla ve bitki verilerini tek yerde toplar. Fotoğrafla bitkini analiz et, tarlanı takip et, uydu verilerini incele ve tarımla ilgili sorularını yapay zekâya sor.',
  note: 'Gör. Anla. Takip et. Tarlanı yanında taşıyabileceğin akıllı bir tarım asistanı.',
  cue: 'Keşfetmek için kaydır',
  cta: 'Uygulamayı İndir',
  cta2: 'Uygulamayı İncele',
  deep: 'Kararın kökü burada başlıyor.',
};

/* Uygulama indirme bağlantısı (tek yerden yönetiliyor) */
export const DOWNLOAD_URL = 'https://agrenai.com/indir';

/* ACT 02 — teknoloji */
export const act02 = {
  title: ['Uydu Görüşünü, Yapay Zekayı', 've Ziraat Bilgisini Birleştiriyoruz'],
  lede: 'Tarım on yıllardır ilaca güveniyor. Girdi fiyatları yükseldikçe ve zararlılar direnç kazandıkça bu düzeni sürdürmek zorlaşıyor.',
  concepts: [
    { k: 'Tespit', v: 'Bitki bitki tarama' },
    { k: 'Uydu', v: 'Sentinel-2 NDVI' },
    { k: 'Hassasiyet', v: 'Sadece gereken yere' },
    { k: 'Koruma', v: 'Verim riske girmez' },
  ],
};

/* ACT 03 — toprak makro */
export const act03 = {
  label: 'Toprak analizi',
  title: 'Gözün göremediği yerden başlıyoruz',
  lede: 'Toprağın nemi, bitkinin klorofili ve tarlanın sağlığı, tek bir bakışla anlaşılmıyor. Ölçülmesi gerekiyor.',
  readout: 'Mikrobiyal aktivite',
};

/* ACT 04 — körlemesine ilaçlama */
export const act04 = {
  kicker: 'Sorun',
  title: ['Körlemesine İlaçlama', 'Sınırına Dayandı'],
  cta: 'Demo İste',
  stages: [
    { axis: 8, label: 'Artan direnç', cap: 'Yabancı ot ve zararlılar, klasik ilaçların yetişebileceğinden daha hızlı adapte oluyor' },
    { axis: 29, label: 'Yükselen girdi maliyeti', cap: 'Aynı korumayı sağlayabilmek için daha fazla ilaç, daha fazla işçilik ve daha fazla yakıt gerekiyor' },
    { axis: 50, label: 'Toprağa ve suya sızıntı', cap: 'Hedefi bulmayan her damla toprağa ve suya karışıyor, geri kazanılmıyor' },
    { axis: 71, label: 'Daralan kâr', cap: 'Tüm tarlaya aynı ilaç atıldıkça maliyet büyüyor, kârı korumak her sezon zorlaşıyor' },
    { axis: 92, label: 'Çevresel yük', cap: 'İlaçlar pahalılaşıyor ve etkisi azalıyor. Zararlı adapte oluyor, çiftçi daha çok ilaçlıyor, her ek uygulama maliyeti büyütüyor.' },
  ],
};

/* ACT 05 — görüş + aksiyon */
export const act05 = {
  left: 'Görüş',
  right: 'Aksiyon',
  gem: 'Artık Çalışıyor',
  cap: ['Yapay zeka tehdidi tanıyabilir, uydu tarlayı izleyebilir,', 'çiftçi bitki düzeyinde karar verebilir'],
};

/* ACT 06 — tarla zekâsı ve risk */
export const act06 = {
  brandTag: 'Tarla zekâsı',
  states: [
    { id: 's1', title: 'Tarlan bir bütün değil', cap: 'Aynı parselin içinde bile sağlık, nem ve baskı birbirinden farklı' },
    { id: 's2', title: 'Risk haritası çıkıyor', cap: 'Uydu her geçişte tarlanı yeniden okuyor, riskli bölgeler renkleniyor' },
    { id: 's3', title: 'Nereye bakacağını biliyorsun', cap: 'Tüm tarlayı değil, sadece işaretli bölgeyi konuşuyorsun' },
  ],
  risk: {
    label: 'Risk seviyesi',
    scale: ['Çok yüksek', 'Yüksek', 'Orta', 'Düşük', 'Çok düşük'],
  },
  /* konumlar havadan çekimdeki gerçek parsellere denk geliyor */
  detections: [
    { id: 'd1', label: 'Darıcan %76', x: 44, y: 20, level: 'high', side: 'left' },
    { id: 'd2', label: 'Darıcan %84', x: 69, y: 33, level: 'high', side: 'right' },
    { id: 'd3', label: 'Darıcan %10', x: 41, y: 63, level: 'low', side: 'left' },
    { id: 'd4', label: 'Darıcan %8', x: 71, y: 73, level: 'low', side: 'right' },
  ],
};

/* ACT 07 — tarama, analiz, müdahale */
export const act07 = {
  kicker: 'Nasıl çalışır',
  steps: [
    { no: '01', title: 'Tarla Taraması', body: 'Uydu ve kamera tarlayı bitki bitki tarar. Yabancı ot, hastalık ve su stresi işaretlenir.' },
    { no: '02', title: 'Yapay Zeka Analizi', body: 'Model riski sınıflandırır, hangi bölgenin müdahale istediğini ve hangisinin beklemesi gerektiğini söyler.' },
    { no: '03', title: 'Hassas Müdahale', body: 'İlaç tüm tarlaya değil, sadece işaretli noktaya gider. Kalan alan temiz kalır.' },
  ],
};

/* ACT 08 — tek sistem */
export const act08 = {
  title: ['Tek Sistem.', 'Tespitten Müdahaleye'],
  cards: [
    { t: 'Tarla Zekâsı', b: 'Uydu haritaları, sağlık ve nem okumaları' },
    { t: 'Çiftlik Paneli', b: 'Tüm parseller, maliyet ve verim tek ekranda' },
    { t: 'Hassas Müdahale', b: 'Sadece gereken noktaya, gereken kadar' },
  ],
};

/* ACT 09 — ekonomi */
export const act09 = {
  title: ['Daha Az Kimyasal,', 'Daha İyi Ekonomi'],
  items: [
    { k: 'Daha az ilaç', v: 25, suffix: '%', cap: 'Tüm tarla yerine sadece riskli bölgeye uygulama', img: 'chem1', img2: 'chem2' },
    { k: 'Daha düşük işletme gideri', v: 18, suffix: '%', cap: 'Daha az geçiş, daha az yakıt, daha az işçilik', img: 'cost1', img2: 'cost2' },
    { k: 'Daha iyi kâr marjı', v: 12, suffix: '%', cap: 'Girdi düşerken verim korunuyor', img: 'margin1', img2: 'margin2' },
    { k: 'Korunan verim', v: 0, suffix: '', cap: 'Müdahale erken yapıldığı için ürün baskı altında kalmıyor', img: 'yield', img2: 'yield' },
  ],
  note: 'Değerler pilot tarlalardaki ölçümlerin ortalamasıdır. Kendi tarlanda çıkan sayı toprağına, ürününe ve sezona göre değişir.',
};

/* ACT 10 — farklı ürünler */
export const act10 = {
  title: ['Farklı Ürünler ve', 'Farklı Tarla Koşulları'],
  lede: 'Sistem tek bir ürüne göre kurulmadı. Tarla, bahçe ve sera koşullarında aynı mantıkla çalışır.',
  chips: ['Mısır', 'Buğday', 'Ayçiçeği', 'Bağ', 'Meyve bahçesi', 'Sera', 'Pamuk'],
};

/* ACT 11 — hassas tarıma geçiş */
export const act11 = {
  title: ['Körlemesine Kimyadan', 'Hassas Tarıma'],
  panels: [
    { k: 'Tarla risk skoru', v: '0,32', s: 'düşük' },
    { k: 'Kimyasal azaltımı', v: '%25', s: 'sezon ortalaması' },
  ],
};

/* ACT 12 — kapanış */
export const act12 = {
  title: ['Hassasiyetle', 'başla.'],
  lede: 'Tarlanın sınırlarını beraber çizelim, ilk sağlık haritanı çıkaralım. Ücretsiz, taahhütsüz.',
  cta: 'Demo İste',
  fields: [
    { id: 'ad', label: 'Ad soyad', type: 'text', ph: 'Mehmet Yılmaz', required: true, autoComplete: 'name' },
    { id: 'tel', label: 'Telefon', type: 'tel', ph: '05xx xxx xx xx', required: true, autoComplete: 'tel' },
    { id: 'yer', label: 'İl ve ilçe', type: 'text', ph: 'Konya, Çumra', required: true },
  ],
  button: 'Beni arayın',
  fine: 'Numaranı yalnız bu görüşme için kullanırız. Reklam mesajı göndermeyiz.',
  success: 'Aldık. En geç bir iş günü içinde arayacağız.',
};

/* ACT 13 — koyu final */
export const act13 = {
  title: 'Daha Azıyla Büyüt',
  sub: 'Daha sağlıklı ürün ve daha güçlü ekonomi için hassas tarım',
  items: ['Uydu takibi', 'Hastalık tespiti', 'Sulama planı', 'Ziraat desteği'],
};

/* ACT 14 — başa dönüş */
export const act14 = {
  title: ['Daha çok üret.', 'Daha az ilaçla.'],
  cta: 'Agren AI ile tanış',
};

export const footer = {
  copyright: '© 2026 Agren AI',
  links: [
    { label: 'Sorun', href: '#sorun' },
    { label: 'Sistem', href: '#sistem' },
    { label: 'Demo İste', href: '#demo' },
  ],
  fine: 'Uydu verisi Copernicus Sentinel-2 kaynaklıdır. Tarımsal öneriler Tarım ve Orman Bakanlığı yayınlarına dayanır ve ziraat mühendisi görüşünün yerini tutmaz.',
};
